import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { Content } from '../../interface/Content';
import { Paginated } from '@/interfaces/Paginate';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getLastContent = async (url: string) => {
  const { data } = await api.get<Paginated<Content>>(url);
  return data.data;
};

export const useGetLastContent = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.entertainment.content.lastViews
      : apiConfig.routes.entertainment.content.lastViewsPublic;

  return useQuery({
    queryKey: ['last', 'content', url],
    queryFn: () => getLastContent(url),
  });
};
